export const EmailValidation = {
  form: jQuery('#frmUserRegistration'),
  emailField: jQuery('#registration-email'),
  parsleyRemoteContainer: jQuery('#parsleyRemote'),
  confirmBox: jQuery('#email-confirm'),
  suggestBox: jQuery('#email-suggest'),
  spinner: jQuery('#frmUserRegistration .ajax-spinner'),
  status: 'valid',
  typeNum: 1487336001,

  init: function () {
    EmailValidation.initAjaxValidation();
    EmailValidation.addEmailValidation();
    EmailValidation.initEventHandler();
  },

  getCsrfToken: function () {
    var metaTag = document.querySelector('meta[name="email-validation-token"]');
    return metaTag ? metaTag.getAttribute('content') : '';
  },

  initAjaxValidation: function () {
    var csrfToken = EmailValidation.getCsrfToken();

    window.Parsley.addAsyncValidator('emailValidation', function (xhr) {
      // Handle CSRF token error
      if (xhr.status === 403) {
        EmailValidation.showErrorMessage('Security token expired. Please reload the page.');
        return false;
      }

      // Handle rate limiting
      if (xhr.status === 429) {
        EmailValidation.showErrorMessage('Too many requests. Please try again later.');
        return false;
      }

      if (!xhr.responseJSON) {
        EmailValidation.hideRemoteOverlay();
        return true;
      }

      if (xhr.responseJSON.valid === true) {
        EmailValidation.hideRemoteOverlay();
        return true;
      } else {
        // Show Suggested E-Mail if exists
        if (xhr.responseJSON.did_you_mean) {
          EmailValidation.suggestBox.find('.confirm').html(xhr.responseJSON.did_you_mean);
          EmailValidation.suggestBox.show();
        } else {
          EmailValidation.suggestBox.find('.confirm').html('');
          EmailValidation.suggestBox.hide();
        }
        EmailValidation.showRemoteOverlay();
        return false;
      }
    }, '/?type=' + EmailValidation.typeNum +
      '&tx_meineinkauffe_emailvalidation[email]={value}' +
      '&tx_meineinkauffe_emailvalidation[token]=' + encodeURIComponent(csrfToken));
  },

  addEmailValidation: function () {
    EmailValidation.emailField.attr('data-parsley-remote', '');
    EmailValidation.emailField.attr('data-parsley-remote-validator', 'emailValidation');
    EmailValidation.emailField.attr('data-parsley-trigger', 'focusout');
    EmailValidation.emailField.attr('data-parsley-trigger-after-failure', 'input');
    EmailValidation.emailField.attr('data-parsley-debounce', '800');

    // Reinitialize Parsley otherwise focusout will not work
    var parsleyField = EmailValidation.emailField.parsley();
    if (parsleyField) {
      parsleyField.destroy();
      EmailValidation.emailField.parsley();
    }
  },

  removeEmailValidation: function () {
    EmailValidation.emailField.removeAttr('data-parsley-remote');
    EmailValidation.emailField.removeAttr('data-parsley-remote-validator');
  },

  initEventHandler: function () {
    EmailValidation.suggestBox.find('.confirm').on('click', function () {
      EmailValidation.removeEmailValidation();
      EmailValidation.emailField.val($(this).html());
      EmailValidation.hideRemoteOverlay();
      EmailValidation.form.parsley().validate();
    });

    EmailValidation.confirmBox.find('.confirm').on('click', function () {
      EmailValidation.removeEmailValidation();
      EmailValidation.hideRemoteOverlay();
      EmailValidation.form.parsley().validate();
    });

    EmailValidation.confirmBox.find('.cancel').on('click', function () {
      EmailValidation.hideRemoteOverlay();
    });

    EmailValidation.emailField.on('input', function () {
      // Only re-add validation if it was removed (after confirm/cancel)
      if (!EmailValidation.emailField.attr('data-parsley-remote')) {
        EmailValidation.addEmailValidation();
      }
      // Reset parsley field state to prevent input-triggered revalidation
      // (Parsley validates on every keystroke after a field fails once)
      var parsleyField = EmailValidation.emailField.parsley();
      if (parsleyField && parsleyField.validationResult === false) {
        parsleyField.reset();
      }
      EmailValidation.suggestBox.hide();
    });

    // show spinner before mail validation
    window.Parsley.on('field:validate', function () {
      if (this.$element.attr('id') == 'registration-email') {
        EmailValidation.spinner.show();
      }
    });

    // hide spinner after mail validation
    window.Parsley.on('field:validated', function () {
      if (this.$element.attr('id') == 'registration-email') {
        EmailValidation.spinner.hide();
      }
    });
  },

  hideRemoteOverlay: function () {
    EmailValidation.parsleyRemoteContainer.hide();
    EmailValidation.confirmBox.hide();
    EmailValidation.suggestBox.hide();
  },

  showRemoteOverlay: function () {
    EmailValidation.confirmBox.find('span').html(EmailValidation.emailField.val());
    EmailValidation.parsleyRemoteContainer.show();
    EmailValidation.confirmBox.show();
    if (EmailValidation.suggestBox.find('.confirm').html().length > 0) {
      EmailValidation.suggestBox.show();
    }
  },

  showErrorMessage: function (message) {
    EmailValidation.parsleyRemoteContainer.show();
    EmailValidation.confirmBox.find('span').html(message);
    EmailValidation.confirmBox.show();
    EmailValidation.suggestBox.hide();
  }
};
